import Axios from "axios";

export const SelectNomenclatureBQ = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/NOME?cat=BQ&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({
        type: "NOMENCLATUREBQ_SELECT",
        payload: response.data,
      });
    });
  };
};
